import {DataTable, DataTableProps} from '@hconnect/uikit/src/lib2'
import {Theme, alpha, SxProps} from '@mui/material'
import {useMemo} from 'react'

interface PlannerDataTableProps<T> extends Omit<DataTableProps<T>, 'rowSx'> {
  rowSx?: (row: T) => SxProps<Theme>
  isRowSelected?: (row: T) => boolean
  isRowClickable?: (row: T) => boolean
}

export const PlannerDataTable = <T,>({
  rowSx,
  isRowSelected,
  isRowClickable,
  ...dataTableProps
}: PlannerDataTableProps<T>) => {
  const defaultRowSx: SxProps<Theme> = useMemo(
    () => ({
      '&:hover': {
        backgroundColor: ({palette}) => alpha(palette.primary.light, 0.03)
      }
    }),
    []
  )

  const resolvedRowSx = (row: T): SxProps<Theme> => ({
    ...defaultRowSx,
    cursor: isRowClickable?.(row) ? 'pointer' : 'default',
    backgroundColor: isRowSelected?.(row)
      ? ({palette}: Theme) => alpha(palette.primary.light, 0.05)
      : undefined,
    ...(rowSx?.(row) as object)
  })

  return <DataTable rowSx={resolvedRowSx} {...dataTableProps} />
}
